import React from 'react';

import BaseComponentProperty from "../index";

export default class Divider extends BaseComponentProperty {
}
